<template>
  <p>People stuff for 2022</p>
</template>
